import React from 'react';

import {
  DEFAULT_FILTERS_CONFIGURATION,
  propTypeGroupRent, propTypeGroupValuesRent,
} from 'shared-constants/src/filters';
import { filterOldCategory } from 'shared-constants/src/filters/old';
import { FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT, filterSectionNames } from 'shared-constants/src/filters/utils';
import { filterBoxesConfiguration } from 'shared-constants/src/filters/groups';
import { isArray, isValidVar } from 'shared-utils/src/checkVarType';
import isEqual from '@lodash/isEqual';
import includes from '@lodash/includes';
import { formatCurrency } from '@common/i18n/helpers';

export const boldWrap = (text, additionaClass = null) => (<b key={text} className={`tp--b c-txt--f0 tp--ell${additionaClass ? ` ${additionaClass}` : ''}`}>{text}</b>);

export const checkDisableFilters = ({ filter, queryFilters, filterConf }) => {

  Object.keys(queryFilters).forEach((key) => {
    switch (key) {
      case 'onlyPrivateNegotiation':
        if (queryFilters[key] === true) {
          if (
            filter === 'price' ||
            filter === 'priceType' ||
            filter === 'payment' ||
            filter === 'mqPrice'
          ) {
            filterConf.disableFromConf = true;
          }
        }
        break;
      case 'priceMin':
      case 'priceMax':
      case 'paymentMin':
      case 'paymentMax':
      case 'mqpriceMin':
      case 'mqpriceMax':
        if (queryFilters[key] && queryFilters[key] !== 'all') {
          if (filter === 'onlyPrivateNegotiation') {
            filterConf.disableFromConf = true;
          }
        }
        break;
      default:
        break;
    }
  });

};

export const getFilterData = (name) => {
  let result = DEFAULT_FILTERS_CONFIGURATION[name];

  // Adding new keys in DEFAULT_FILTERS_CONFIGURATIONS seems to break MyCasa
  // So I'm gonna add this amazing check
  if (name === 'propertyTypeGroup-affitto-breve') {
    result = propTypeGroupRent;
  } else if (name === 'oldcategory') {
    result = filterOldCategory;
  }

  return result;
};

export const getDisplayValue = (filter, value) => {
  const filterData = getFilterData(filter) || {};
  let shortRentWorkaround = value;

  // as in getFilterData
  // Adding new keys in DEFAULT_FILTERS_CONFIGURATIONS seems to break MyCasa
  // So I'm gonna add this amazing check
  if (filter === 'propertyTypeGroup-affitto-breve' && value === 'casa') {
    shortRentWorkaround = 'case-vacanza';
  }

  const val = (filterData.values || []).filter((item) => item.value === shortRentWorkaround)[0];
  if (!val) return undefined;
  return filter === 'tr' ? val.display.toLowerCase() : val.display;
};

/**
 * Returns the values as a preview.
 * Used as previews in filter sections
 * @param {Object} filters Current selected filters
 * @param {String} filterName Filter name
 * @param {String} filterValue Current filter value
 * @returns {String}
 */
export const getPreviewFromFilters = (filters, filterName, filterValue, isAgencySrp) => {
  let result = getDisplayValue(filterName, filterValue);
  const channel = filters.tr !== undefined ? filters.tr : filters.channel;

  // Handle exceptions
  switch (filterName) {

    case 'tr':
      if (!filterValue) {
        result = 'Vendita, Affitto, Affitto breve';
      }
      if (isAgencySrp && filterValue === 'vendita') {
        result = 'Comprare';
      }
      break;
    case 'propertyTypeGroup':
      if (channel === 'affitto-breve') {
        result = getDisplayValue('propertyTypeGroup-affitto-breve', filterValue);
      }

      // if (propertyTypes.length === 1) {
      //   [result] = propertyTypes;
      // } else if (propertyTypes.length > 1) {
      //   result = propertyTypes.join(', ');
      // }
      break;
  }

  return result;
};

export const getValuesExcluded = (values, excludeValues, toExcludeKeys, filters = {}) => values.filter((filt) => {
  const valuesToExclude = toExcludeKeys.reduce((obj, ex) => {
    ex === filt.value && obj.push(excludeValues[ex]);
    return obj;
  }, []);
  let toExclude = false;

  valuesToExclude.map((exc) => {
    const excludeArr = Array.isArray ? exc : [exc];

    excludeArr.forEach((exclude) => {
      const valueFilter = filters[exclude.type];

      if (valueFilter && valueFilter === exclude.value) {
        toExclude = true;
      }
    });
  });

  return !toExclude;
});

export const checkExcludeValues = (originalValues, valuesDependsOn, excludeValues = {}, dependsOn, filters = {}) => {
  let toExcludeKeys = Object.keys(excludeValues);
  let result = valuesDependsOn;

  if (toExcludeKeys.length && Array.isArray(originalValues)) {
    result = getValuesExcluded(originalValues, excludeValues, toExcludeKeys, filters);
  } else if (toExcludeKeys.length && !Array.isArray(originalValues) && dependsOn) {
    const keyType = filters[dependsOn];
    const valueToExcludeSelected = excludeValues[keyType];

    if (valueToExcludeSelected) {
      toExcludeKeys = Object.keys(valueToExcludeSelected);
      result = getValuesExcluded(valuesDependsOn, valueToExcludeSelected, toExcludeKeys, filters);
    }
  }

  return result;
};

/**
 * Get values from specific  filter
 */
export const getValues = (filter, filters = {}) => {
  const filterData = getFilterData(filter);
  const { dependsOn, excludeValues } = filterData;
  let result = filterData.values || [];
  if (dependsOn) {
    if (filters[dependsOn]) {
      result = filterData.values[filters[dependsOn]];
    } else if (filter === 'price') {
      result = filterData.values.vendita;
    }
  }

  result = checkExcludeValues(filterData.values, result, excludeValues, dependsOn, filters);

  // Handle exceptions
  switch (filter) {
    case 'propertyTypeGroup':
      // if (filters.pId) {
      //   result = getFilterData('oldcategory').values;
      // }
      if (filters.tr === 'affitto-breve') {
        result = propTypeGroupValuesRent;
      }
      break;
    case 'propertyTypes':
      result = !isArray(result) ? [] : result;
      break;
    case 'priceType':
      // exclude mortgage rate filter for the following propertyTypeGroups & propertyTypes
      if (
        [
          'commerciale',
          'terreno',
          'stanza',
          'garage-posti-auto',
        ].indexOf(filters.propertyTypeGroup) > -1
        // || (filters.propertyTypes.length === 1 && filters.propertyTypes[0] === 'Attività/Licenza commerciale')
      ) {
        result = [...result].slice(0, 2);
      }
      break;
  }

  return result;
};

export const getActiveFilters = (filtersList) => {
  const filtersData = DEFAULT_FILTERS_CONFIGURATION;
  const activeFiltersList = {};
  let activeFiltersCount = 0;

  Object.keys(filtersList).forEach((filterName) => {
    if (filterName in filtersData) {
      const filterList = filtersList[filterName];
      const filterData = filtersData[filterName];
      if ('defaultMinValue' in filterData) {
        const rangeObj = filterList || {};
        if (rangeObj.min !== filterData.defaultMinValue || (rangeObj.max === undefined ? null : rangeObj.max) !== filterData.defaultMaxValue) {
          activeFiltersList[filterName] = filtersList[filterName];
          if (FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT.indexOf(filterName) === -1) {
            activeFiltersCount += 1;
          }
        }
        return;
      }
      const { defaultValue } = filterData;
      switch (typeof filterList) {
        case 'string':
        case 'boolean':
          if (filterList !== defaultValue) {
            activeFiltersList[filterName] = filterList;
            if (FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT.indexOf(filterName) === -1) {
              activeFiltersCount += 1;
            }
          }
          break;
        default:
          if (!isEqual(filterList, defaultValue)) {
            activeFiltersList[filterName] = filterList;
            if (FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT.indexOf(filterName) === -1) {
              activeFiltersCount += 1;
            }
          }
      }
    } else if (filterName.indexOf('Min') > -1 || filterName.indexOf('Max') > -1) {
      const isMin = filterName.indexOf('Min') > -1;
      const parentFilterName = filterName.replace('Min', '').replace('Max', '');
      const filterData = filtersData[parentFilterName];

      if (filterData) {
        if (isMin) {
          if (filtersList[`${parentFilterName}Min`] !== filterData.defaultMinValue) {
            activeFiltersList[`${parentFilterName}Min`] = filtersList[`${parentFilterName}Min`];
            activeFiltersCount += 1;
          }
        } else if (filtersList[`${parentFilterName}Max`] !== filterData.defaultMaxValue) {
          activeFiltersList[`${parentFilterName}Max`] = filtersList[`${parentFilterName}Max`];
          if (!(`${parentFilterName}Min` in activeFiltersList)) {
            activeFiltersCount += 1;
          }
        }
      }
    }
  });

  if (filtersList.poi) {
    activeFiltersList.poi = filtersList.poi;
    activeFiltersCount += 1;
  }

  // lift_level is a synthetic key (not in DEFAULT_FILTERS_CONFIGURATION) needed by createFilterLabels
  if (filtersList.lift_level != null) {
    activeFiltersList.lift_level = filtersList.lift_level;
  }

  return {
    activeFiltersList,
    activeFiltersCount,
  };
};

export const getActiveFiltersCountWithPTypes = (filters) => {
  let { activeFiltersCount } = getActiveFilters(filters);
  if (filters.propertyTypes && filters.propertyTypes.length) {
    activeFiltersCount += 1;
  }
  return activeFiltersCount;
};

export const getFilterBoxes = () => ({
  box1: Object.keys(filterBoxesConfiguration.box1),
  box2: Object.keys(filterBoxesConfiguration.box2),
  box3: Object.keys(filterBoxesConfiguration.box3),
  box4: Object.keys(filterBoxesConfiguration.box4),
  box5: Object.keys(filterBoxesConfiguration.box5),
});

export const getFilterLists = (visible) => {
  const {
    box1,
    box2,
    box3,
    box4,
    box5,
  } = getFilterBoxes();

  const allFilters = [
    ...box1,
    ...box2,
    ...box3,
    ...box4,
    ...box5,
  ];

  const hiddenFilters = allFilters.slice(visible - 1);

  return {
    allFilters,
    hiddenFilters,
    box1,
    box2,
    box3,
    box4,
    box5,
  };
};

// Based on filter configuration, reset hidden to default values
export const resetHiddenFilters = (filters) => {
  const filterKeys = Object.keys(filters);
  return filterKeys.reduce((acc, filter) => {
    const conf = DEFAULT_FILTERS_CONFIGURATION[filter];
    const isHidden = conf?.isVisible && !conf.isVisible(filters);
    acc[filter] = isHidden ? conf?.defaultValue : filters[filter];
    return acc;
  }, {});
};

export const createFilterLabels = (filterName, filterValues, channel, isAgencySrp) => {
  let result;

  const labelFrom = 'da';
  const labelTo = 'a';

  const getFirstValidValue = (types, apx) => types
    .filter(type => filterValues[`${type}${apx}`])
    .map(type => filterValues[`${type}${apx}`])[0];

  const createPriceDescr = () => {
    const mqPrice = filterValues.mqPrice;
    const payment = filterValues.payment;
    if (mqPrice && (mqPrice.min != null || mqPrice.max != null)) return ' al m²';
    if (payment && (payment.min != null || payment.max != null)) return ' al mese';
    return '';
  };

  switch (filterName) {
    case 'propertyTypeGroup': {
      let value = filterValues.propertyTypeGroup || getFilterData('propertyTypeGroup').defaultValue;
      value = getPreviewFromFilters({ channel }, 'propertyTypeGroup', value);

      result = !!value && <>Cerco {boldWrap(value)}</>;
      break;
    }
    case 'tr': {
      const defValue = isAgencySrp
        ? 'Comprare'
        : getFilterData('tr').defaultValue;
      const value = filterValues.tr || defValue;
      result = !!value && <>${isAgencySrp ? 'per' : 'in'} {boldWrap(getDisplayValue('tr', value).toLowerCase())}</>;
      break;
    }
    case 'price': {
      const priceTypes = getFilterData('priceType').values.map(type => type.value);
      const getActivePriceVal = (types, side) => {
        const match = types.find(t => filterValues[t] && filterValues[t][side] != null);
        return match ? filterValues[match][side] : null;
      };
      const from = getActivePriceVal(priceTypes, 'min');
      const to = getActivePriceVal(priceTypes, 'max');
      const renderCurr = (curr, pfx = '') => pfx
        ? <>{pfx}&nbsp;{boldWrap(formatCurrency(curr).replace(',00', ''))}</>
        : <>{boldWrap(formatCurrency(curr).replace(',00', ''))}</>;
      const typePrice = createPriceDescr(from, to);
      const tr = filterValues.excludePrivateNegotiation === true
        ? { short: '(escl. trattat. riserv.)', full: 'escludi trattative riservate' }
        : filterValues.onlyPrivateNegotiation === true
          ? { short: '(solo trattat. riserv.)', full: 'solo trattative riservate' }
          : null;
      result = !!(from || to) &&
        from && to ?
        <>{renderCurr(from, labelFrom)}&nbsp;{renderCurr(to, labelTo)}&nbsp;{typePrice}{tr && <>&nbsp;{tr.short}</>}</> :
        from ?
          <>{renderCurr(from, labelFrom)}&nbsp;{typePrice}{tr && <>&nbsp;{tr.short}</>}</> :
          to ?
            <>fino a&nbsp;{renderCurr(to)}&nbsp;{typePrice}{tr && <>&nbsp;{tr.short}</>}</> :
            tr ? <>{boldWrap(tr.full)}</> : '';
      break;
    }
    case 'mq': {
      const mqRange = filterValues.mq;
      const from = mqRange && typeof mqRange === 'object' ? mqRange.min : null;
      const to = mqRange && typeof mqRange === 'object' ? mqRange.max : null;
      result = !!(from || to) &&
        from && to ?
        <>da&nbsp;{boldWrap(from)}&nbsp;a&nbsp;{boldWrap(`${to} m²`)}</> :
        from ?
          <>da&nbsp;{boldWrap(`${from} m²`)}</> :
          to ?
            <>fino a&nbsp;{boldWrap(`${to} m²`)}</> : '';
      break;
    }
    case 'rooms': {
      const roomsRange = filterValues.rooms;
      const [numRoomsMin, numRoomsMax] = roomsRange && typeof roomsRange === 'object'
        ? [roomsRange.min !== 'all' ? roomsRange.min : null, roomsRange.max !== 'all' ? roomsRange.max : null]
        : roomsRange && roomsRange !== 'all' ? roomsRange.split('-') : [null, null];
      const from = numRoomsMin && parseFloat(numRoomsMin);
      const to = numRoomsMax && parseFloat(numRoomsMax);
      const sub = 'locale';
      const subs = 'locali';
      result = !!(from || to) &&
        from && to ?
        <>da&nbsp;{boldWrap(from)}&nbsp;a&nbsp;{boldWrap(`${to} ${subs}`)}</> :
        from ?
          <>da&nbsp;{boldWrap(`${from} ${from > 1 ? subs : sub}`)}</> :
          to ?
            <>fino a&nbsp;{boldWrap(`${to} ${to > 1 ? subs : sub}`)}</> : '';

      if (from && to && from === to) {
        if (to === 1) {
          result = <>solo&nbsp;{boldWrap('Monolocali')}</>;
        } else if (to === 2) {
          result = <>solo&nbsp;{boldWrap('Bilocali')}</>;
        } else if (to === 3) {
          result = <>solo&nbsp;{boldWrap('Trilocali')}</>;
        } else if (to === 4) {
          result = <>solo&nbsp;{boldWrap('Quadrilocali')}</>;
        } else {
          result = <>solo&nbsp;{boldWrap(`${to} ${subs}`)}</>;
        }
      }

      break;
    }
    case 'baths': {
      const bathroomsRange = filterValues.bathrooms;
      var bMin = bathroomsRange && typeof bathroomsRange === 'object'
        ? (bathroomsRange.min != null ? bathroomsRange.min : null)
        : (bathroomsRange && bathroomsRange !== 'all' ? bathroomsRange.split('-')[0] : null);
      const value = bMin ? parseInt(bMin, 10) : null;
      const label = value > 1 ? 'bagni' : 'bagno';
      result = !!value && <>con almeno&nbsp;{boldWrap(`${value} ${label}`)}</>;
      break;
    }
    case 'rentType': {
      const value = filterValues.rentType;
      const label = 'con contratto'
      result = !!value && <>{label}&nbsp;{boldWrap(`${value === 'seasonalRental' ? 'transitorio' : 'a lungo termine'}`)}</>;
      break;
    }

    case 'parkingSpaces': {
      const psRange = filterValues.parkingSpaces;
      const value = psRange && typeof psRange === 'object'
        ? psRange.min
        : (psRange && psRange !== 'all' ? psRange : null);
      const label = value > 1 ? 'box/posti auto' : 'box/posto auto';
      result = value != null && <>con almeno {boldWrap(`${value} ${label}`)}</>;
      break;
    }
    case 'level': {
      const rawVal = filterValues.level;
      // SM getFilters() returns { gte: N } for numeric levels — extract the number
      const value = rawVal && typeof rawVal === 'object' && 'gte' in rawVal ? rawVal.gte : rawVal;
      const getStrValue = (val) => { // eslint-disable-line
        // current numeric format (from SM round-trip)
        if (val === 0) return <>al&nbsp;{boldWrap('piano terra')}</>;
        if (val === 999) return <>a un&nbsp;{boldWrap('piano intermedio')}</>;
        if (val === 1000) return <>all'{boldWrap('ultimo piano')}</>;
        // v1.0 string format (from direct filter state)
        switch (val) {
          case 'piano terra':
            return <>al&nbsp;{boldWrap('piano terra')}</>;
          case 'intermedio':
            return <>a un&nbsp;{boldWrap('piano intermedio')}</>;
          case 'ultimo':
            return <>all'{boldWrap('ultimo piano')}</>;
        }
      };
      const strVal = getStrValue(value);
      result = value != null && value !== false && (strVal || <>dal&nbsp;{boldWrap(`${value}° piano in su`)}</>);
      break;
    }
    case 'lift': {
      const value = filterValues.lift;
      const liftLevel = filterValues.lift_level;
      let subValue;

      if (liftLevel != null && !isNaN(liftLevel)) {
        const title = `con ascensore, oltre ${liftLevel}° piano`;
        subValue = <span title={title}>con&nbsp;{boldWrap('ascensore')}, oltre il&nbsp;{boldWrap(`${liftLevel}° piano`)}</span>;
      } else if (value === true || value === 'true') {
        subValue = <>con&nbsp;{boldWrap('ascensore')}</>;
      } else if (value === false || value === 'false') {
        subValue = boldWrap('senza ascensore');
      } else if (!isNaN(value)) {
        const title = `con ascensore, oltre ${value}° piano`;
        subValue = <span title={title}>con&nbsp;{boldWrap('ascensore')}, oltre il&nbsp;{boldWrap(`${value}° piano`)}</span>;
      }

      result = !!subValue && subValue;
      break;
    }
    case 'heating': {
      const value = filterValues.heating || [];
      const getStrValue = (val) => {
        const labelAut = 'autonomo';
        const labelCent = 'centralizzato';
        const inclAut = includes(val, labelAut);
        const inclCent = includes(val, labelCent);
        let res = '';

        if (inclAut && inclCent) {
          res = 'riscaldamento';
        } else if (inclAut) {
          res = 'riscaldamento autonomo';
        } else if (inclCent) {
          res = 'riscaldamento centralizzato';
        }

        return res;
      };
      result = value.length && <>con&nbsp;{boldWrap(getStrValue(value))}</>;
      break;
    }
    case 'garden': {
      const value = filterValues.garden || [];
      const getStrValue = (val) => {
        const label1 = 'comune';
        const label2 = 'privato';
        const incl1 = includes(val, label1);
        const incl2 = includes(val, label2);
        let res = '';

        if (incl1 && incl2) {
          res = 'giardino';
        } else if (incl1) {
          res = 'giardino comune';
        } else if (incl2) {
          res = 'giardino privato';
        }

        return res;
      };
      result = value.length && <>con&nbsp;{boldWrap(getStrValue(value))}</>;
      break;
    }

    case 'energyClass': {
      const value = filterValues.energyClass;
      result = !!value && <>con&nbsp;{boldWrap('classe energetica')}&nbsp;almeno&nbsp;{boldWrap(value)}</>;
      break;
    }
    case 'condition': {
      const value = filterValues.condition || [];
      const values = [];
      let subValue;

      if (includes(value, 'nuovo-ristrutturato')) {
        values.push('nuovo o ristrutturato');
      }
      if (includes(value, 'abitabile')) {
        values.push('in buone condizioni');
      }
      if (includes(value, 'da-ristrutturare')) {
        values.push('da ristrutturare');
      }

      if (values.length) {
        subValue = (
          <>
            {values.map(el => boldWrap(el, el)).reduce(
              (prev, curr) => <>{prev} o {curr}</>,
            )}
          </>
        );
      }

      result = subValue;
      break;
    }
    case 'constructionYear': {
      const from = filterValues.constructionYear?.min;
      const to = filterValues.constructionYear?.max;
      result = !!(from || to)
        && (
          <>
            costruita
            {
              from && to ?
                <> tra il&nbsp;{boldWrap(from)}&nbsp;e il&nbsp;{boldWrap(to)}</> :
                from ?
                  <> a partire dal&nbsp;{boldWrap(from)}</> :
                  to ?
                    <> entro il&nbsp;{boldWrap(to)}</> : ''
            }
          </>
        );
      break;
    }
    case 'availability': {
      let value;

      switch (filterValues.availability) {
        case 'occupato':
          value = 'occupato al rogito';
          break;
        case 'libero':
          value = 'libero al rogito';
          break;
        case 'nuda-proprieta':
        case 'nuda proprieta':
          value = 'in nuda proprietà';
          break;
        case 'affittato':
          value = 'affittato al rogito';
          break;
      }

      result = !!value && boldWrap(value);
      break;
    }
    case 'publisher': {
      const value = filterValues.publisher;
      result = !!value && <>da&nbsp;{boldWrap(value)}</>;
      break;
    }

    /*
      TECH-139 - filtri
    */

    case 'furniture': {
      const { furniture } = filterValues;
      const value = furniture || [];
      const values = {
        no: 'non arredato',
        parzialmente: 'solo cucina',
        completamente: 'arredato',
      };
      if (value.length === 3) {
        result = <>{boldWrap('non arredato')}&nbsp;o&nbsp;{boldWrap('solo cucina')}&nbsp;o&nbsp;{boldWrap('arredato')}</>;
      } else if (value.length === 2) {
        if (!includes(value, 'no')) {
          result = <>{boldWrap('arredato')}&nbsp;o&nbsp;{boldWrap('solo cucina')}</>;
        } else if (includes(value, 'parzialmente')) {
          result = <>{boldWrap('non arredato')}&nbsp;o&nbsp;{boldWrap('solo cucina')}</>;
        } else {
          result = <>{boldWrap('non arredato')}&nbsp;o&nbsp;{boldWrap('arredato')}</>;
        }
      } else if (value.length) {
        result = <>{boldWrap(values[value[0]])}</>;
      }
      break;
    }

    // case 'hasAC': {
    //   const { hasAC } = filterValues;
    //   if (hasAC) {
    //     result = <>Solo <strong>Immobili all'asta</strong></>;
    //   } else if (hasAC === false) {
    //     result = <>Esclusi <strong>Immobili all'asta</strong></>;
    //   }
    //   break;
    // }

    case 'publicationDt': {
      const { publicationDt } = filterValues;
      const values = {
        '2d': 'ultime 48 ore',
        '7d': 'ultima settimana',
        '30d': 'ultimo mese',
      };

      const articles = {
        '2d': 'pubblicato nelle ',
        '7d': 'pubblicato nell\'',
        '30d': 'pubblicato nell\'',
      };
      if (publicationDt && articles[publicationDt]) {
        result = <>{articles[publicationDt]}{boldWrap(values[publicationDt])}</>;
      } else {
        result = null;
      }
      break;
    }

    /*
      TECH-139 - filtri
    */

    case 'isAuction': {
      const { isAuction } = filterValues;
      if (isAuction) {
        result = <>solo&nbsp;{boldWrap('aste')}</>;
      } else if (isAuction === false) {
        result = <>escludi&nbsp;{boldWrap('aste')}</>;
      }
      break;
    }

    case 'balconyTerrace': {
      const { balconyTerrace } = filterValues;
      if (balconyTerrace) {
        const { length } = balconyTerrace;
        const [value] = balconyTerrace;
        if (length && value) {
          if (length === 2) {
            result = <>con&nbsp;{boldWrap('balcone')}&nbsp;o&nbsp;{boldWrap('terrazzo')}</>;
          } else if (value === 'terrazzo') {
            result = <>con&nbsp;{boldWrap('terrazzo')}</>;
          } else {
            result = <>con&nbsp;{boldWrap('balcone')}</>;
          }
        }
      }
      break;
    }

    case 'includes_property_ownership': {
      const { includes_property_ownership } = filterValues;
      if (includes_property_ownership) {
        result = <>solo&nbsp;{boldWrap(`${includes_property_ownership === 'true' ? 'con' : 'senza'} mura`)}</>;
      }
      break;
    }

    case 'commercial_building_location': {
      const { commercial_building_location } = filterValues;
      if (commercial_building_location) {
        const valuesArr = !Array.isArray(commercial_building_location)
          ? commercial_building_location.split(',')
          : commercial_building_location;
        const displayValues = valuesArr.map(val => DEFAULT_FILTERS_CONFIGURATION.commercial_building_location.values.filter(el => el.value === val)[0].display);
        const last = displayValues.pop();
        result = <>solo&nbsp;{boldWrap(`${displayValues.join(', ')}${displayValues.length ? ' e ' : ''}${last}`)}</>;
      }
      break;
    }

    default: break;
  }

  const defaulFilterName = () => {
    if (filterName !== 'price') {
      return filterSectionNames[filterName];
    }

    return channel && channel !== 'vendita'
      ? filterSectionNames[`${filterName}_rent`]
      : filterSectionNames[filterName];
  };

  return {
    result: result || defaulFilterName(),
    isActive: (isValidVar(result) && result !== '' && result !== 0 && result !== false),
  };
};
